import { Component, OnDestroy, OnInit, ViewChild, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConfig } from 'app/app.config';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { ISlimScrollOptions, SlimScrollEvent } from 'ngx-slimscroll';
import { Observable } from 'rxjs';
import { SecurityService } from 'app/shared/services/security.service';
import { OpeningService } from '../../opening/opening.service';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { CustomerService } from '../customer.service';
import { BudgetService } from '../budget.service';
import { IDtoBudgetList } from 'app/shared/models/quote/dto-budget-list.model';
import { IUser } from 'app/shared/models/user.model';
import { IDtoBudgetFilter } from 'app/shared/models/quote/budget-filter.model';
import { IDtoCustomer } from 'app/shared/models/customer/dto-customer.model';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ModalDuplicateBudgetComponet } from 'app/views/modales/budget/duplicate/modal-duplicate.component';
import { ModalBudgetVersionsComponet } from 'app/views/modales/budget/versions/modal-versions.component';
import { StorageService } from 'app/shared/services/storage.service';
import { IDtoModuleLog } from 'app/shared/models/security/dto-module-log.model';
import { IdentityService } from '../../security/identity.service';

@Component({
    selector: 'app-list-budgets',
    styleUrls: ['./list-budgets.style.scss'],
    templateUrl: './list-budgets.template.html'
})
export class ListBudgetsComponent implements OnDestroy, OnInit {
    /**Formularios */
    private formFilter: FormGroup;
    /**Catalogos */
    private catalogCustomers: Observable<IDtoCatalog[]>;
    private catalogProjectCustomers: Observable<IDtoCatalog[]>;
    /**Variables */
    private now: number;
    private town: string;
    private state: string;
    private staffType: string;
    /**Modales */
    private modalRef: BsModalRef;
    /** Tablas*/
    @ViewChild(DatatableComponent, { static: false }) tableBudgets: DatatableComponent;
    /**Slim-control */
    optsSlim: ISlimScrollOptions;
    scrollEvents: EventEmitter<SlimScrollEvent>;
    private profile: string;
    private user: IUser;
    private budgetsList: IDtoBudgetList[];
    private budgetsListTemp: IDtoBudgetList[];
    private budget: IDtoBudgetList;
    private budgetDuration: number;
    private search: string;
    @ViewChild('swalDuplicate', { static: false }) private swalDuplicate: SwalComponent;
    @ViewChild('swalDelete', { static: false }) private swalDelete: SwalComponent;
    public constructor(private formBuilder: FormBuilder
        , private configGeneral: AppConfig
        , private openingService: OpeningService
        , private budgetService: BudgetService
        , private router: Router
        , private route: ActivatedRoute
        , private spinner: NgxSpinnerService
        , private configurationService: ConfigurationService
        , private securityService: SecurityService
        , private customerService: CustomerService
        , private modalService: BsModalService
        , private storageService: StorageService
        , private identityService: IdentityService) {
        this.profile = this.securityService.getProfileStorage('Budgets');
        this.user = this.securityService.getUserDataStorage();
        this.optsSlim = configGeneral.getConfigSlimScroll();
        this.initializeFormFilter();
    }
    ngOnInit(): void {
        this.scrollEvents = new EventEmitter<SlimScrollEvent>();
        this.now = Date.now();
        if (this.configurationService.isReady) {
            //this.spinner.show();
            this.getCatalogs();
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
                //this.spinner.show();
                this.getCatalogs();
            });
        }
        this.initFilters();
    }
    ngOnDestroy(): void {
    }
    private initFilters(): void {
        const customer = this.storageService.retrieve('budgets.customer');
        const staffType = this.storageService.retrieve('budgets.staffType');
        if (customer != null) {
          this.formFilter.get('customerId').patchValue(+customer);
          let dto = { id: customer, additional: staffType } as IDtoCatalog;
          this.changeCustomer(dto);
        }
        const project = this.storageService.retrieve('budgets.project');
        if (project != null) {
          this.formFilter.get('projectCustomerId').patchValue(+project);
        }
        const search = this.storageService.retrieve('budgets.search');
        if (search != undefined) {
          this.search = search;
        }
        if (customer != null || project != null) {
            this.getBudgetsByFilter();
        }
    }
    private initializeFormFilter() {
        this.formFilter = this.formBuilder.group({
            projectCustomerId: [null],
            customerId: [null]
        });
    }
    private changeCustomer(dto: IDtoCatalog): void {
        if (dto == undefined) {
            return;
        }
        this.staffType = dto.additional;
        this.catalogProjectCustomers = null;
        this.formFilter.get('projectCustomerId').setValue(null);
        if (dto === undefined) {
            return;
        }
        switch (this.profile) {
            case 'Ejecutivo':
                this.catalogProjectCustomers = this.budgetService.getCatalogProjectsByCustomerIdAndEjecutive(dto.id, this.user.userId);
                break;
            case 'Cliente':
                this.catalogProjectCustomers = this.budgetService.getCatalogProjectsByCustomerIdAndApprover(dto.id, this.user.userId);
                break;
            default:
                this.catalogProjectCustomers = this.budgetService.getCatalogProjectCustomersByCustomerId(dto.id);
                break;
        }
    }
    private handleRefusal(dismissMethod: string): void {
    }
    private confirmDuplicateBudget(row: IDtoBudgetList, duration: number): void {
        this.budgetDuration = +duration;
        this.budget = row;
        this.swalDuplicate.title = '¿Seguro que desea duplicar el presupuesto seleccionado?';
        this.swalDuplicate.show();
    }
    // private duplicateBudget(): void {
    //     this.budgetService.duplicateBudget(this.budget).subscribe(x => {
    //         if (x.isCorrect) {
    //             this.configGeneral.newToast('Éxito', x.message, 'success');
    //             this.getBudgetsByFilter();
    //         } else {
    //             this.configGeneral.newToast('Error', x.message, 'error');
    //         }

    //     })
    // }
    private confirmDeleteBudget(row: IDtoBudgetList): void {
        this.budget = row;
        this.swalDelete.title = '¿Seguro que desea eliminar el presupuesto seleccionado?';
        this.swalDelete.show();
    }
    private deleteBudget(): void {
        this.budgetService.deleteBudget(this.budget.id).subscribe(x => {
            if (x.isCorrect) {
                this.configGeneral.newToast('Éxito', x.message, 'success');
                this.getBudgetsByFilter();
                this.addModuleLog(this.budget.id, 'delete');
            } else {
                this.configGeneral.newToast('Error', x.message, 'error');
            }

        })
    }
    private navigateTo(row: IDtoBudgetList): void {
        const values = this.formFilter.getRawValue() as IDtoBudgetFilter;
        this.storageService.store('budgets.customer', values.customerId);
        this.storageService.store('budgets.project', values.projectCustomerId);
        this.storageService.store('budgets.search', this.search);
        this.storageService.store('budgets.staffType', this.staffType)
        this.router.navigate(['/budgets/create',
            { id: row.id, action: 'update' }], { relativeTo: this.route });
    }
    private getCatalogs(): void {
        if (this.profile == 'Ejecutivo') {
            this.catalogCustomers = this.customerService.getCatalogCustomersByExecutive(this.user.userId);
        } else {
            this.catalogCustomers = this.customerService.getCatalogCustomers();
            this.catalogCustomers.subscribe(res => {
                if (this.profile == 'Cliente') {
                    this.customerService.getCustomerByApproverUserId(this.user.userId).subscribe(x => {
                        if (x.isCorrect) {
                            const cust = x.data as IDtoCustomer;
                            this.formFilter.get('customerId').setValue(cust.id);
                            this.formFilter.get('customerId').disable();
                            let dto = {} as IDtoCatalog;
                            dto.id = cust.id;
                            dto.name = cust.name;
                            this.changeCustomer(dto);
                        } else {
                            this.configGeneral.newToast('Restricción', x.message, 'error');
                            this.formFilter.get('customerId').disable();
                        }
                    })
                }
            })
        }
    }
    private getBudgetsByFilter(): void {
        const values = this.formFilter.getRawValue() as IDtoBudgetFilter;
        if (this.profile == 'Cliente') {
            if (values.customerId == null || values.projectCustomerId == null) {
                this.configGeneral.newToast('Validación', 'Debe seleccional un cliente y proyecto', 'warning');
                return;
            }
        }
        if (this.profile == 'Ejecutivo' || this.profile == 'Facturacion') {
            if (values.customerId == null) {
                this.configGeneral.newToast('Validación', 'Debe seleccional un cliente', 'warning');
                return;
            }
        }
        values.profile = this.profile;
        values.userId = this.user.userId;
        this.budgetService.getBudgetsByFilter(values).subscribe((res) => {
            this.budgetsList = res.data as IDtoBudgetList[];
            this.budgetsListTemp = this.budgetsList;
            this.spinner.hide();
            if (this.search != undefined) {
                this.updateFilter();
            }
        });
    }
    private updateFilter() {
        if (this.search === undefined) {
            return;
        }

        const val = this.search.toLowerCase();
        const temp = this.budgetsListTemp.filter((x: any) => x.projectCustomerName.toLowerCase().startsWith(val)
            || x.planTrademarkName.toLowerCase().startsWith(val)
            || x.statusName.toLowerCase().startsWith(val)
            || x.classification.toLowerCase().startsWith(val)
            || x.startDate.toLowerCase().startsWith(val)
            || x.planTypeName.toLowerCase().startsWith(val)
            || x.id.toString().startsWith(val)
            || x.version.toString().startsWith(val)
            || x.duration.toString().startsWith(val)
            || x.comments.toLowerCase().indexOf(val) !== -1 || !val);

        this.budgetsList = temp;
        this.tableBudgets.offset = 0;
    }
    private openModalDuplicate(row: IDtoBudgetList) {
        this.budget = row;
        const initialState = {
            title: `Duplicar presupuesto número ${row.id}`,
            budget: this.budget
        };
        this.modalRef = this.modalService.show(ModalDuplicateBudgetComponet
            , Object.assign({ initialState }
                , this.configGeneral.configModal));
        this.modalRef.content.onClose.subscribe((result) => {
            if (result) {
                this.getBudgetsByFilter();
            } else {
                this.spinner.hide();
                this.configGeneral.newToast('Error', 'Ocurrió un error al intentar guardar los datos, intente de nuevo', 'error');
            }
        });
    }
    private getBudgetVersions(row: IDtoBudgetList): void {
        this.spinner.show();
        this.budgetService.getBudgetVersions(row.id).subscribe(x => {
            let list = x.data as IDtoBudgetList[];
            this.spinner.hide();
            if (list.length == 0) {
                this.configGeneral.newToast('Error', 'No existen versiones asociadas a este presupuesto', 'warning');
            } else {
                this.openModalVersions(list, row);
            }
        });
    }
    private openModalVersions(list: IDtoBudgetList[], row: IDtoBudgetList) {
        const initialState = {
            title: `Versiones del presupuesto ${row.id}`,
            budgetsList: list
        };
        this.modalService.show(ModalBudgetVersionsComponet
            , Object.assign({ initialState }
                , { class: 'modal-lg' }
                , this.configGeneral.configModal));
    }
    private addModuleLog(id: number, action: string): void {
        let dto = {} as IDtoModuleLog;
        dto.table = 'Budgets';
        dto.module = 'budgets';
        dto.action = action;
        dto.registryAffectedId = id;
        this.identityService.addModuleLog(dto).subscribe(
            (x) => { });
    }
}
